export enum SystemType {
    HeatPumpSystem = 'HeatPumpSystem',
    PhotovoltaicSystem = 'PhotovoltaicSystem',
    VentilationSystem = 'VentilationSystem'
}
